export default "__VITE_ASSET__NhqTXzWJ__"